import { render, staticRenderFns } from "./quesAnswer.vue?vue&type=template&id=57a7daa8&scoped=true"
import script from "./quesAnswer.vue?vue&type=script&lang=js"
export * from "./quesAnswer.vue?vue&type=script&lang=js"
import style0 from "./quesAnswer.vue?vue&type=style&index=0&id=57a7daa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a7daa8",
  null
  
)

export default component.exports